import { createSlice } from '@reduxjs/toolkit';
import { getDashboardData } from './thunks';

// Initial state for Redux store:
export const initialStateDashboard = {
  loading: false,
  data: {},
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialStateDashboard, // Define initial state
  reducers: {
    setDrawers: (state: any, action: any) => {
      state.drawers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setDrawers } = dashboardSlice.actions;

// Export reducer generated by "createSlice()":
export default dashboardSlice.reducer;
